export const AppMessages = {
  SYSTEM_ERROR_HAS_BEEN_ERROR: 'Hệ thống đã xảy ra lỗi',
  INVALID_DATA: 'Dữ liệu không hợp lệ',
}


